import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/common/SEO';
import Button from '../components/common/Button';

const NotFound = () => {
  return (
    <>
      <SEO
        title="404 - Page Not Found | Confident Portraits"
        description="The page you're looking for doesn't exist. Return to Confident Portraits homepage or explore our portfolio."
        url="/404"
      />
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary to-secondary px-4">
        <div className="text-center">
        <h1 className="text-9xl font-heading font-bold text-white mb-4">404</h1>
        <h2 className="text-4xl font-heading font-semibold text-white mb-4">
          Page Not Found
        </h2>
        <p className="text-xl text-gray-200 mb-8 max-w-md mx-auto">
          Sorry, the page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-4 justify-center">
          <Link to="/">
            <Button variant="primary" size="lg">
              Go Home
            </Button>
          </Link>
          <Link to="/portfolio">
            <Button variant="outline" size="lg" className="bg-white text-secondary hover:bg-gray-100">
              View Portfolio
            </Button>
          </Link>
        </div>
      </div>
      </div>
    </>
  );
};

export default NotFound;
